import makeStyles from '@mui/styles/makeStyles';
import sunrise from './seeking.svg';

const BACKGROUND_STYLES = {
  background: `url(${sunrise})`,
  backgroundSize: 'cover',
  backgroundPosition: 'bottom',
  height: '100%',
  width: '100%'
};

export const useStyles = makeStyles(() => ({
  background: BACKGROUND_STYLES,
  container: {
    textAlign: 'center',
    margin: 'auto',
    fontWeight: 'bold',
    marginTop: '15%',
    textShadow: '1px 1px 3px #FFDB71'
  },
  offlineBackground: {
    ...BACKGROUND_STYLES,
    filter: 'grayscale(100%)',
    '-webkit-filter': 'grayscale(100%)'
  }
}));
